<template>
  <div>
    <div class="d-flex">
      <ActionButton
        :callback="click"
        :text="text"
        :title="title"
        :btn-class="btnClass"
        :classes="classes"
        :variant="variant"
      />
      <slot :name="'button-right'"></slot>
    </div>
    <b-modal
      scrollable
      ref="container"
      size="xl"
      :id="title || (dataId || '').replace(/ /g, '_')"
      :title="title"
      @hidden="cancel"
      hide-footer
      modal-class="modal right fade"
      :dialog-class="
        dialogClass || 'modal-dialog modal-dialog-slideout modal-dialog-slideout-right modal-dialog-slideout-xl'
      "
      content-class="no-max-height"
      :body-class="bodyClass || ''"
    >
      <div class="p-3">
        <loading v-if="loading"></loading>
        <slot :name="'body'" v-else-if="show" v-bind="{ cancel }"></slot>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  inject: ['$validator'],
  name: 'ActionButtonModal',
  props: {
    dataId: String,
    text: String,
    title: String,
    classes: String,
    onShow: Function,
    onLoadEdit: Function,
    onLoadEditData: Object | String,
    variant: String,
    dialogClass: String,
    btnClass: String,
    bodyClass: String
  },
  data() {
    return {
      show: false,
      loading: false
    };
  },
  methods: {
    async click() {
      try {
        this.loading = true;
        this.onLoadEdit && (await this.onLoadEdit(this.onLoadEditData));
        this.onShow && (await this.onShow());
        this.show = true;
        this.$refs.container.show();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    cancel() {
      this.$refs.container.hide();
      this.tempItem = JSON.parse(JSON.stringify(this.item || {}));
      if (this.rawData) {
        this.tempItem = this.rawData(this.tempItem);
      }
      this.show = false;
    }
  },
  components: {
    ActionButton: () => import('./ActionButton')
  }
};
</script>
